module.exports = __webpack_public_path__ + "img/2.b0fa04f1.png";